import { createGroq } from "@ai-sdk/groq";
import { createBlockNoteAIClient } from "@blocknote/xl-ai";

// Environment variable helper
function getEnv(key) {
  // In a React app, environment variables need to be prefixed with VITE_
  return import.meta.env[`VITE_${key}`] || process.env[key];
}

// Optional: proxy requests through the `@blocknote/xl-ai-server` proxy server
// For now, we'll use direct API calls
const client = createBlockNoteAIClient({
  apiKey: getEnv("GROQ_API_KEY") || "PLACEHOLDER",
  baseURL:
    getEnv("BLOCKNOTE_AI_SERVER_BASE_URL") || "https://localhost:3000/ai",
});

// Use Groq model for AI functionality
export const createAIModel = () => {
  const apiKey = getEnv("GROQ_API_KEY");

  if (!apiKey || apiKey === "PLACEHOLDER") {
    console.warn("GROQ_API_KEY not found. AI features will be limited.");
    // Return a mock model for development
    return null;
  }

  return createGroq({
    apiKey: apiKey,
  })("llama-3.3-70b-versatile");
};

// Custom AI menu items
export const makeInformal = (editor) => ({
  title: "Make Informal",
  onItemClick: () => {
    // This will be handled by the AI extension
    editor.aiMenu?.executeAICommand({
      prompt:
        "Rewrite the selected text to be more casual and informal while keeping the same meaning.",
    });
  },
  aliases: ["casual", "informal", "relaxed"],
  group: "Style",
});

export const addRelatedTopics = (editor) => ({
  title: "Add Related Topics",
  onItemClick: () => {
    editor.aiMenu?.executeAICommand({
      prompt:
        "Add a section with related topics and subtopics based on the current content. Format as a bulleted list.",
    });
  },
  aliases: ["topics", "related", "expand"],
  group: "Content",
});

export const improveWriting = (editor) => ({
  title: "Improve Writing",
  onItemClick: () => {
    editor.aiMenu?.executeAICommand({
      prompt:
        "Improve the selected text by making it clearer, more concise, and better structured while maintaining the original meaning.",
    });
  },
  aliases: ["improve", "enhance", "refine"],
  group: "Style",
});

export const summarize = (editor) => ({
  title: "Summarize",
  onItemClick: () => {
    editor.aiMenu?.executeAICommand({
      prompt:
        "Create a concise summary of the selected text, highlighting the key points.",
    });
  },
  aliases: ["summary", "tldr", "brief"],
  group: "Content",
});

export const expandContent = (editor) => ({
  title: "Expand Content",
  onItemClick: () => {
    editor.aiMenu?.executeAICommand({
      prompt:
        "Expand on the selected text by adding more details, examples, and explanations while maintaining the same tone and style.",
    });
  },
  aliases: ["expand", "elaborate", "detail"],
  group: "Content",
});
